import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Globe } from 'lucide-react';

const LanguageSelector = ({ variant = 'default', showLabel = false }) => {
  const { language, setLanguage, languages, t } = useLanguage();
  const [open, setOpen] = useState(false);

  const currentLang = languages[language];

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button 
          variant={variant === 'ghost' ? 'ghost' : 'outline'} 
          size={showLabel ? 'default' : 'icon'}
          className="gap-2"
          data-testid="language-selector"
        >
          <Globe className="h-4 w-4" />
          {showLabel && (
            <span className="hidden sm:inline">{currentLang?.nativeName || 'English'}</span>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <div className="px-2 py-1.5 text-sm font-semibold text-muted-foreground">
          {t('select_language')}
        </div>
        {Object.values(languages).map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => {
              setLanguage(lang.code);
              setOpen(false);
            }}
            className={`cursor-pointer ${language === lang.code ? 'bg-primary/10 text-primary font-medium' : ''}`}
            data-testid={`lang-${lang.code}`}
          >
            <span className="flex-1">{lang.nativeName}</span>
            <span className="text-xs text-muted-foreground ml-2">{lang.name}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSelector;
